const init = {
  busy: true,
  error: null,
  availableLayouts: null,
};

const reducer = (state = init, action) => {
  switch (action.type) {
    case 'FETCH_AVAILABLE_LAYOUTS':
      return {
        ...state,
        busy: true,
        error: null,
      };
    case 'FETCH_AVAILABLE_LAYOUTS_FULFILLED': {
      return {
        ...state,
        availableLayouts: action.payload || [],
        busy: false,
      };
    }
    case 'FETCH_AVAILABLE_LAYOUTS_REJECTED':
      return {
        ...state,
        busy: false,
        error: action.payload,
      };
    case 'CLEAR_AVAILABLE_LAYOUTS': {
      return {
        ...state,
        availableLayouts: null,
      };
    }
    default:
      return state;
  }
};

export default reducer;



// WEBPACK FOOTER //
// ./src/photobooks/reducers/contentLayout/reducer.js